import { render, staticRenderFns } from "./AutoWhitelist.vue?vue&type=template&id=544e9110&"
import script from "./AutoWhitelist.vue?vue&type=script&lang=js&"
export * from "./AutoWhitelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports